import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { verifyPayment } from '../../Api/Api';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { MdErrorOutline, MdCheckCircle } from 'react-icons/md';

const PaymentFailure = () => {
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('Processing payment failure...');
  const [statusType, setStatusType] = useState('loading'); // 'loading', 'fail', 'partial'
  const navigate = useNavigate();

  useEffect(() => {
    const txnid = searchParams.get('txnid');
    const status = searchParams.get('status');

    if (txnid && status === 'failed') {
      verifyPayment(txnid, status)
        .then((data) => {
          if (data.success) {
            setStatusType('partial');
            setMessage('⚠️ Payment failed. Your order status has been updated.');
          } else {
            setStatusType('fail');
            setMessage('❌ Failed to update payment status.');
          }
          setTimeout(() => {
            navigate('/');
          }, 3000);
        })
        .catch(() => {
          setStatusType('fail');
          setMessage('❌ Error contacting the server.');
        });
    } else {
      setStatusType('fail');
      setMessage('❌ Invalid or missing transaction details.');
    }
  }, [searchParams]);

  const renderIcon = () => {
    if (statusType === 'loading') {
      return (
        <AiOutlineLoading3Quarters className="text-blue-500 animate-spin text-4xl mb-2" />
      );
    }
    if (statusType === 'partial') {
      return <MdCheckCircle className="text-yellow-500 text-5xl mb-2 mx-auto block" />;
    }
    return <MdErrorOutline className="text-red-500 text-5xl mb-2  mx-auto block" />;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white shadow-lg rounded-xl p-8 max-w-md w-full text-center">
        {renderIcon()}
        <h2 className="text-xl font-semibold text-gray-700">{message}</h2>
        <p className="mt-4 text-sm text-gray-500">You will be redirected shortly...</p>
      </div>
    </div>
  );
};

export default PaymentFailure;
